<template>
  <div>
    <integrationsOauthApplications
      v-if="isOauth && appDetails"
      :appSelected="appDetails"
      :connection="connectionDetails"
      :hasConnection="isConnection"
      @activateConnection="activateConnection"
    ></integrationsOauthApplications>
    <integrationsNonOauthApplications
      v-if="isNoAauth && appDetails"
      :appSelected="appDetails"
      :connection="connectionDetails"
      :hasConnection="isConnection"
      @activateConnection="activateConnection"
    ></integrationsNonOauthApplications>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/index";
import integrationsNonOauthApplications from "./integrationsNonOauthApplications.vue";
import integrationsOauthApplications from "./integrationsOauthApplications.vue";
export default {
  computed: {
    ...mapGetters("globalApis", [
      "getApplicationDetails",
      "getConnectionDetails",
    ]),
  },
  components: {
    integrationsOauthApplications,
    integrationsNonOauthApplications,
  },
  async mounted() {
    await this.app();
  },
  data() {
    return {
      isOauth: false,
      isNoAauth: false,
      appDetails: null,
      isConnection: false,
      connectionDetails: null,
    };
  },
  methods: {
    activateConnection(data) {
      this.isConnection = true;
      this.connectionDetails = data;
    },
    async app() {
      await store.dispatch("globalApis/getApplication", this.$route.query.app);
      if (this.$route.query.connection) {
        await store.dispatch(
          "globalApis/getConnection",
          this.$route.query.connection
        );
        this.connectionDetails = this.getConnectionDetails.data;
        this.isConnection = true;
      }
      if (this.getApplicationDetails.data) {
        if (this.getApplicationDetails?.data?.settings?.isOauthAuthenticating) {
          this.isOauth = true;
        } else {
          this.isNoAauth = true;
        }
        this.appDetails = this.getApplicationDetails.data;
      } else {
        return;
      }
    },
  },
};
</script>
